export class ColumnExcel {
    column : string;
    field : string;
    hidden: boolean = false;
}